import { useMemo } from "react";

const COLORS = ["#E91E8C", "#F5C6D6", "#FFD700", "#38BDF8", "#ffffff"];

export default function GiftAnimation({ emoji, fxKey }) {
  const items = useMemo(
    () =>
      Array.from({ length: 24 }).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.7,
        dur: 1.8 + Math.random() * 1.4,
        size: 18 + Math.random() * 22,
        confetti: i % 3 === 0,
        color: COLORS[i % COLORS.length],
      })),
    // regenerate per animation trigger
    [fxKey] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none overflow-hidden" data-testid="gift-animation">
      <div className="absolute left-1/2 top-1/3 -translate-x-1/2" style={{ fontSize: "5rem", animation: "gift-pop 1.5s ease-out forwards" }}>
        {emoji}
      </div>
      {items.map((it, i) =>
        it.confetti ? (
          <span
            key={i}
            className="absolute top-0"
            style={{ left: `${it.left}%`, width: 8, height: 13, background: it.color, borderRadius: 2, animation: `gift-fall ${it.dur}s linear ${it.delay}s forwards` }}
          />
        ) : (
          <span key={i} className="absolute top-0" style={{ left: `${it.left}%`, fontSize: it.size, animation: `gift-fall ${it.dur}s linear ${it.delay}s forwards` }}>
            {emoji}
          </span>
        )
      )}
    </div>
  );
}
